module.exports = __webpack_public_path__ + "img/portfolio_3.f2c61924.png";